/* Filthy Clean — make the buybox star rating scroll to the Judge.me reviews
   section (reviews_fc) at the bottom of the product page. The stars are the
   stock Tinker `review` block (no link), which we don't edit — so we enhance
   additively here. Scoped to the main product section only, so rating stars
   inside product cards (collection grids, related products) are untouched. */
(function () {
  function init() {
    var reviews = document.querySelector('[id$="__reviews_fc"]');
    var stars = document.querySelector('[id$="__main"] .rating-wrapper');
    if (!reviews || !stars || stars.classList.contains('fc-rating-link')) return;
    stars.classList.add('fc-rating-link');
    stars.setAttribute('role', 'link');
    stars.setAttribute('tabindex', '0');
    stars.setAttribute('aria-label', 'Jump to customer reviews');
    function go() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      reviews.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    stars.addEventListener('click', go);
    stars.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        go();
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
